import React from "react";

export default function PhoneSetupTipsCard() {
  return (
    <div
      style={{
        width: "min(76.5vw, 510px)",
        maxWidth: "calc(100% - 48px)",
        marginLeft: "auto",
        marginRight: "auto",
        background: "linear-gradient(180deg, rgba(18, 24, 42, 0.95), rgba(11, 15, 26, 0.95))",
        border: "2px solid rgba(72, 221, 124, 0.6)",
        borderRadius: "20px",
        padding: "28px",
        boxShadow: "0 20px 60px rgba(0,0,0,.6), inset 0 1px 1px rgba(255,255,255,.1)",
        marginBottom: "4vh",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          textAlign: "center",
          marginBottom: "24px",
          borderBottom: "2px solid rgba(72, 221, 124, 0.3)",
          paddingBottom: "16px",
        }}
      >
        <div
          style={{
            fontSize: "clamp(20px, 4vw, 28px)",
            fontWeight: 900,
            fontFamily: "'Arial Black', Impact, Arial, sans-serif",
            color: "#48dd7c",
            textShadow: "0 0 10px rgba(72, 221, 124, 0.5)",
            marginBottom: "6px",
          }}
        >
          📱 Optimize Your Phone
        </div>
        <div style={{ fontSize: "clamp(13px, 2vw, 16px)", opacity: 0.85 }}>
          For the best quiz experience
        </div>
      </div>

      <div style={{ marginBottom: "24px" }}>
        <div
          style={{
            fontSize: "clamp(16px, 3vw, 20px)",
            fontWeight: 700,
            color: "#48dd7c",
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span>🔋</span>
          <span>Turn Off Battery Saver / Low Power Mode</span>
        </div>

        <div
          style={{
            fontSize: "clamp(13px, 2vw, 15px)",
            lineHeight: 1.6,
            opacity: 0.9,
            marginBottom: "12px",
            paddingLeft: "28px",
          }}
        >
          Battery saver modes can pause the quiz timer and disconnect you from the game.
        </div>

        <div
          style={{
            background: "rgba(72, 221, 124, 0.1)",
            border: "1px solid rgba(72, 221, 124, 0.3)",
            borderRadius: "10px",
            padding: "14px",
            marginLeft: "28px",
          }}
        >
          <div style={{ fontWeight: 700, marginBottom: "6px", fontSize: "clamp(13px, 2vw, 15px)" }}>
            How to change:
          </div>
          <div style={{ fontSize: "clamp(12px, 1.8vw, 14px)", lineHeight: 1.6, opacity: 0.9 }}>
            <div style={{ marginBottom: "6px" }}>
              <strong>Android:</strong> Settings → Battery → Battery Saver → Turn OFF
            </div>
            <div>
              <strong>iOS:</strong> Settings → Battery → Low Power Mode → Turn OFF
            </div>
          </div>
        </div>
      </div>

      <div>
        <div
          style={{
            fontSize: "clamp(16px, 3vw, 20px)",
            fontWeight: 700,
            color: "#48dd7c",
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span>⏱️</span>
          <span>Increase Screen Timeout</span>
        </div>

        <div
          style={{
            fontSize: "clamp(13px, 2vw, 15px)",
            lineHeight: 1.6,
            opacity: 0.9,
            marginBottom: "12px",
            paddingLeft: "28px",
          }}
        >
          A longer screen timeout prevents your screen from locking during questions.
        </div>

        <div
          style={{
            background: "rgba(72, 221, 124, 0.1)",
            border: "1px solid rgba(72, 221, 124, 0.3)",
            borderRadius: "10px",
            padding: "14px",
            marginLeft: "28px",
          }}
        >
          <div style={{ fontWeight: 700, marginBottom: "6px", fontSize: "clamp(13px, 2vw, 15px)" }}>
            How to change:
          </div>
          <div style={{ fontSize: "clamp(12px, 1.8vw, 14px)", lineHeight: 1.6, opacity: 0.9 }}>
            <div style={{ marginBottom: "6px" }}>
              <strong>Android:</strong> Settings → Display → Screen timeout → Select 5-10 minutes
            </div>
            <div>
              <strong>iOS:</strong> Settings → Display & Brightness → Auto-Lock → Select 5-10 minutes
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
